import React, { useState, FormEvent, useContext, useEffect } from "react";
import { Segment, Form, Button, Dropdown, Input, Modal } from "semantic-ui-react";
import { IProject as IProject } from "../../../app/models/project";
import { v4 as uuid } from "uuid";
import MobileStore from "../../../app/stores/mobileStore";
import { observer } from "mobx-react-lite";
import { RouteComponentProps } from "react-router";

const MobileCreateForm: React.FC<RouteComponentProps> = ({
  match,
  history,
}) => {
  const mobileStore = useContext(MobileStore);
  const { createProject, generate, loadCustomers, customersByName, submitting } = mobileStore;

  useEffect(() => {
    loadCustomers();
  }, []);

  const [project, setProject] = useState<IProject>({
    id: "",
    createdAt: "",
    updatedAt: "",
    projectCode: "",
    jobType: "Mobile",
    category: "",
    customerId: "",
    workType: "",
    siteId: "",
    siteName: "",
    orderNumber: "",
    materialOrderNo: "",
    status: "Quotes Not Yet Submitted",
    address: "",
    receiveDate: "",
    requireDate: "",
    jobStartDate: "",
    estimatedCompletionDate: "",
    invoiceNo: "",
    remark: "",
  });

  const [open, setOpen] = useState(false);

  const customerOptions = customersByName.map(function (customer) {
    var option = { key: customer.id, text: customer.name, value: customer.id };
    return option;
  });

  const handleSubmit = () => {
    createProject(project).then(() =>
      history.push(`/projectmanagement/mobile`)
    );
  };

  const handleInputChange = (
    event: FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setProject({ ...project, [name]: value });
  };

  const categoryOptions = [{ key: "IBC-Colocation 5G Upgrade", text: "IBC-Colocation 5G Upgrade", value: "IBC-Colocation 5G Upgrade" },
                    { key: "5G RANCAP", text: "5G RANCAP", value: "5G RANCAP" },
                    { key: "Macro", text: "Macro", value: "Macro" }];
                  
  const workTypeOptions = [{ key: "Optus", text: "Optus", value: "Optus" },
                    { key: "TPG", text: "TPG", value: "TPG" },
                    { key: "Telstra", text: "Telstra", value: "Telstra" },
                    { key: "Vodafone", text: "Vodafone", value: "Vodafone" },
                    { key: "Ericsson", text: "Ericsson", value: "Ericsson" }];

  return (
    <Segment clearing>
      <Form onSubmit={handleSubmit}>
        <Form.Group>
          <Form.Input
            label="Project Code"
            required
            width="6"
            onChange={handleInputChange}
            name="projectCode"
            placeholder="Project Code"
            value={project.projectCode}
          />
          <Form.Button
            onClick={() =>
              generate().then((code) =>
                setProject({ ...project, ["projectCode"]: code })
              )
            }
            width="2"
            floated="left"
            content="Generate"
            style={{ marginTop: "1.7em" }}
          />
          <Form.Select
            label="Category"
            required
            width="8"
            onChange={(e, { name, value }) =>
              setProject({ ...project, [name]: value })
            }
            name="category"
            placeholder="Category"
            options={categoryOptions}
            value={project.category}
          />
        </Form.Group>
        <Form.Group widths="equal">
        <Form.Select
            label="Customer"
            required
            onChange={(e, { name, value }) =>
              setProject({ ...project, [name]: value })
            }
            options={customerOptions}
            name="customerId"
            placeholder="Customer"
            value={project.customerId}
          />
          <Form.Select
            label="Work Type"
            required
            onChange={(e, { name, value }) =>
              setProject({ ...project, [name]: value })
            }
            options={workTypeOptions}
            name="workType"
            placeholder="Work Type"
            value={project.workType}
          />
        </Form.Group>
        <Form.Input
          label="Site Id"
          required
          onChange={handleInputChange}
          name="siteId"
          placeholder="Site Id"
          value={project.siteId}
        />
        <Form.Input
          label="Site Name"
          required
          onChange={handleInputChange}
          name="siteName"
          placeholder="Site Name"
          value={project.siteName}
        />
        <Form.Input
          label="Job Location"
          onChange={handleInputChange}
          name="address"
          placeholder="Job Location"
          value={project.address}
        />
        <Form.Group widths="equal">
          <Form.Input
            label="Receive Date"
            onChange={handleInputChange}
            name="receiveDate"
            type="date"
            placeholder="Receive Date"
            value={project.receiveDate}
          />
          <Form.Input
            label="Require Date"
            onChange={handleInputChange}
            name="requireDate"
            type="date"
            placeholder="Require Date"
            value={project.requireDate}
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Input
            label="Actual RFQ Submit Date"
            onChange={handleInputChange}
            name="jobStartDate"
            type="date"
            placeholder="Actual RFQ Submit Date"
            value={project.jobStartDate}
          />
          <Form.Input
            label="Expect Delivery Date"
            onChange={handleInputChange}
            name="estimatedCompletionDate"
            type="date"
            placeholder="Expect Delivery Date"
            value={project.estimatedCompletionDate}
          />
        </Form.Group>
        <Form.TextArea
          label="Remark"
          onChange={handleInputChange}
          name="remark"
          rows={2}
          placeholder="Remark"
          value={project.remark}
        />
        <Button
          loading={submitting}
          floated="right"
          positive
          type="submit"
          content="Submit"
        />
        <Button
          onClick={() => history.push("/projectmanagement/mobile")}
          floated="right"
          type="button"
          content="Cancel"
        />
      </Form>
    </Segment>
  );
};

export default observer(MobileCreateForm);
